import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Button } from '@gumtree/ui-library';
import { fontWeights, gutterSizes, fontSizes, colors } from '@gumtree/ui-library/src/base/theme';

export const StyledButton = styled(Button, {
    shouldForwardProp(propName: PropertyKey) {
        return !['gridColumn', 'isMotorsCTATask1'].includes(propName as string);
    },
})<{ gridColumn: string, isMotorsCTATask1?: boolean } & React.ComponentProps<typeof Button>>`
    && {
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        grid-column: ${({ gridColumn }) => gridColumn};
        margin-bottom: ${gutterSizes.medium};
        font-weight: ${fontWeights.bold};
        ${({ isMotorsCTATask1 }) => isMotorsCTATask1 && css`
            font-weight: 600;
            .icon::before {
                height: ${fontSizes.medium};
                width: ${fontSizes.medium};
                background-size: ${fontSizes.medium};
            }
        `}
    }
`;

export const InlineButton = styled(Button)`
    && {
        width: auto;
        height: auto;
        background-color: transparent;
        color: ${colors.blue};
        border: none;
        padding: 0;
        margin: 0;
        font-size: inherit;
    }
`;
